import React, { Component } from "react";
import PrintPreview from "../PrintPreview";
import ReportStore from "stores/ReportStore";
import "./Print.css";

const DEFAULT_ROW = 41;
const tableDetail = {
  cost_supply: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    { label: "จำนวน", field: "quantity", class: "text-center", width: "90px" },
    {
      label: "ต้นทุน/หน่วย",
      field: "cost_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "ผู้ทำรายการ",
      field: "request_by",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ผู้อนุมัติ",
      field: "response_by",
      class: "text-center",
      width: "100px",
    },
  ],
  cost_part: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    { label: "จำนวน", field: "quantity", class: "text-center", width: "90px" },
    {
      label: "ต้นทุน/หน่วย",
      field: "cost_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "ผู้ทำรายการ",
      field: "request_by",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ผู้อนุมัติ",
      field: "response_by",
      class: "text-center",
      width: "100px",
    },
  ],
  cost_purchase: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ชื่อร้าน",
      field: "shop_name",
      class: "text-center",
      width: "150px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    {
      label: "จำนวน",
      field: "item_quantity",
      class: "text-center",
      width: "90px",
    },
    {
      label: "ราคา/หน่วย",
      field: "price_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "มูลค่า",
      field: "amount",
      class: "text-center",
      width: "100px",
      isNumberFormat: true,
    },
  ],
  cost_wage: [
    {
      label: "วันที่ปิดงาน",
      field: "taskclosed_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ชื่อช่าง",
      field: "employee_name",
      class: "text-center",
      width: "150px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    {
      label: "จำนวน(ชั่วโมง)",
      field: "man_hour",
      class: "text-center",
      width: "90px",
    },
    {
      label: "ค่าแรงต่อวัน",
      field: "wage_per_day",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "มูลค่า",
      field: "wage_cost",
      class: "text-center",
      width: "100px",
      isNumberFormat: true,
    },
  ],
};
class PrintReportJobCostSheetDetail extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      loading: false,
      car_detail: {},
      dataList: [],
      data: [],
      report_title: "กำลังดึงข้อมูล..",
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    if (this.props.type != undefined && this.props.workNo != undefined) {
      ReportStore.loadReportJobCostSheetWorkDetail(
        this.props.type,
        this.props.workNo,
        (result) => {
          this.setState({
            data: result.data,
            car_detail: result.car_detail,
            dataList: this.getPagination(result.data),
            report_title: "ไม่พบข้อมูล",
          });
        }
      );
    } else {
      this.setState({
        data: [],
        dataList: this.getPagination([]),
        report_title: "ไม่พบข้อมูล",
      });
    }
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getDetailSummary(field) {
    let { data } = this.state;
    let { type } = this.props;
    let total = 0;
    if (type === "cost_wage") field = "wage_per_day";

    data.forEach((item, index) => {
      if (type === "cost_supply" || type === "cost_part") {
        total += item[field] * item["quantity"];
      } else
        total +=
          item[field] === "" ||
          item[field] === null ||
          item[field] === undefined ||
          isNaN(item[field])
            ? 0
            : item[field] * 1;
    });
    return total;
  }

  getPagination(data) {
    let newData = [];
    let allData = [];
    let checkRow = 0;
    data.forEach(function (item, index) {
      if (checkRow < DEFAULT_ROW) checkRow++;
      newData.push(item);

      if (checkRow === DEFAULT_ROW - 1 || index === data.length - 1) {
        allData.push(newData);
        checkRow = 0;
        newData = [];
      }
    });

    return allData;
  }

  renderRowData(data, indexs) {
    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={8}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{indexs * 40 + index + 1}</td>
          {tableDetail[this.props.type] != undefined
            ? tableDetail[this.props.type].map((ritem, rindex) => {
                if (ritem.isNumberFormat) {
                  return (
                    <td key={rindex} className="text-right">
                      {this.getNumberFormat(item[ritem.field])}
                    </td>
                  );
                } else {
                  return (
                    <td key={rindex} className={ritem.class}>
                      {item[ritem.field]}
                    </td>
                  );
                }
              })
            : ""}
        </tr>
      ));
    }
  }

  renderTable(item, index, length) {
    let { type } = this.props;
    return (
      <table className="table table-print-report-analysis">
        <tbody>
          <tr>
            <td className="text-center" style={{ width: "50px" }}>
              ลำดับ
            </td>
            {tableDetail[this.props.type] != undefined
              ? tableDetail[this.props.type].map((item, index) => {
                  return (
                    <td
                      key={index}
                      className={"text-center"}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </td>
                  );
                })
              : ""}
          </tr>
          {this.renderRowData(item, index)}
          {length - 1 === index ? (
            type === "cost_supply" || type === "cost_part" ? (
              <tr>
                <td colSpan={4} className="text-right">
                  ยอดรวมสุทธิ
                </td>
                <td className="text-right">
                  {this.getNumberFormat(this.getDetailSummary("cost_per_unit"))}
                </td>
                <td colSpan={2} className="text-right"></td>
              </tr>
            ) : (
              <tr>
                <td colSpan={6} className="text-right">
                  ยอดรวมสุทธิ
                </td>
                <td className="text-right">
                  {this.getNumberFormat(this.getDetailSummary("amount"))}
                </td>
              </tr>
            )
          ) : (
            ""
          )}
        </tbody>
      </table>
    );
  }

  renderComponentPage(item, index, length) {
    let { type, workNo } = this.props;
    return (
      <div className="font-print" key={index}>
        <header className="text-center">
          <h2>{this.props.title}</h2>
        </header>
        {type != "" && workNo != "" ? (
          <div>
            {type == "cost_supply"
              ? "ต้นทุนค่าวัสดุสิ้นเปลือง"
              : type == "cost_part"
              ? "ต้นทุนค่าอะไหล่"
              : type == "cost_purchase"
              ? "ต้นทุนจัดซื้อ"
              : " "}
            {" เลขที่งานซ่อม " +
              workNo +
              " ทะเบียนรถ " +
              this.state.car_detail.car_registration_no}
          </div>
        ) : (
          ""
        )}
        <div>{this.renderTable(item, index, length)}</div>
      </div>
    );
  }

  renderNoData() {
    return (
      <div className="font-print">
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    );
  }

  render() {
    let { loading, dataList } = this.state;
    if (dataList.length === 0) {
      return (
        <PrintPreview loading={loading} leftBarTitle={this.props.title}>
          {this.renderNoData()}
        </PrintPreview>
      );
    } else {
      return (
        <PrintPreview loading={loading} leftBarTitle={this.props.title}>
          {dataList.map((item, index) => {
            return this.renderComponentPage(item, index, dataList.length);
          })}
        </PrintPreview>
      );
    }
  }
}

PrintReportJobCostSheetDetail.defaultProps = {
  title: "ตารางรายงาน Job Cost Sheet",
  mode: "",
  workNo: "",
};
export default PrintReportJobCostSheetDetail;



// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportJobCostSheetDetail.js